<template>
    <main class="page-container">
        <s-locale-selector-ribbon :is-shown="isLocaleSelectorShown" />

        <div class="page">
            <s-main-header v-bind="sliceDataHeader" />

            <s-job-description v-bind="jobDescriptionProps" />

            <s-global-footer class="footer" v-bind="sliceDataFooter" />
        </div>
    </main>
</template>

<script>
import Loading from '@uikit/ui-kit/packages/loading/src/directive';
import analytics from '@core/mixins/analytics.js';
import localeRibbon from '@core/mixins/locale-ribbon.js';
import SGlobalFooter from '@core/slices/pages/global-footer/global-footer.vue';
import SJobDescription from '@core/slices/pages/job-description/job-description.vue';
import SLocaleSelectorRibbon from '@core/slices/pages/locale-selector-ribbon/locale-selector-ribbon.vue';
import SMainHeader from '@core/slices/pages/main-header/main-header.vue';
import '@core/styles/sections/pages.pcss';

export default {
    name: 'CareersJobComponent',

    components: {
        SGlobalFooter,
        SJobDescription,
        SLocaleSelectorRibbon,
        SMainHeader,
    },

    directives: {
        Loading,
    },

    mixins: [analytics, localeRibbon],

    computed: {
        sliceDataHeader() {
            return {
                ...this.$store.state.slices.items['s-main-header'],
                theme: 'light',
                isMenuAvailable: true,
            };
        },

        sliceDataFooter() {
            return {
                ...this.$store.state.slices.items['s-global-footer'],
                type: 'withNav',
                theme: 'dark',
                hasBorderTopSocials: true,
            };
        },

        sliceDataJobDescription() {
            return this.$store.state.slices.items['s-job-description'];
        },

        job() {
            return this.$store.state.workday.items[0];
        },

        jobDescriptionProps() {
            return {
                job: this.job,
                ...this.sliceDataJobDescription.jobDescription,
            };
        },
    },
};
</script>

<style lang="postcss" scoped>
.page {
    position: relative;
    display: flex;
    flex-direction: column;

    > * {
        flex-shrink: 0;
    }
}
</style>
